/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiBadge, EuiFlexGroup, EuiFlexItem, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent, ReactElement, ReactNode } from 'react'

const defaultBadge = <FormattedMessage id='title-with-badge.default' defaultMessage='Optional' />

export const CuiTitleWithBadge: FunctionComponent<{
  children: ReactNode
  badge?: string | ReactElement<typeof FormattedMessage>
  id?: string
}> = ({ children, badge = defaultBadge, id }) => (
  <EuiFlexGroup responsive={false} alignItems='center' className='titleWithBadge'>
    <EuiFlexItem grow={false}>
      <EuiTitle size='xs'>
        <h3 id={id}>{children}</h3>
      </EuiTitle>
    </EuiFlexItem>

    <EuiFlexItem grow={false}>
      <EuiBadge>{badge}</EuiBadge>
    </EuiFlexItem>
  </EuiFlexGroup>
)
